import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';

import { Link } from '../business/link/link';
import { LinkService } from '../services/link.service';

/**
 * @deprecated Use LinkSyncPipe instead
 */
@Pipe({
    name: 'link',
    standalone: true,
})
export class LinkPipe implements PipeTransform {
    public constructor(public linkService: LinkService) {}

    /**
     * Transforms Link with LinkService
     * @param {Link} value
     * @param {Map<string, string>} params (optional)
     * @returns {Observable<string>}
     */
    public transform(value: Link, params?: Map<string, string>): Observable<string> {
        return this.linkService.getLink(value, params);
    }
}
